module.exports = __webpack_public_path__ + "img/3cc.194f4874.png";